import React from 'react'
import IconsAuraExp25 from './Images/IconsAuraExp25.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faCircleChevronRight} from '@fortawesome/free-solid-svg-icons';



function ExpCard25() {
  return (

    <div className='ExpPgCard  '>
      
        <p className='ExpPgHExpName'> On the footsteps of different religions  </p>
        

        <p className='ExpPgHCat'> Divine </p>
        <p className='ExpPgHCode'> AURAMUSE125 </p>

        

        <div className='IconsAuraExpDiv'>  <img className='IconsAuraExp' src={IconsAuraExp25} /> </div>

        <FontAwesomeIcon className='FaIconCirc' icon={faCircleChevronRight} size="xl" style={{color: " ", }} />
        

    </div>




    
  )
}

export default ExpCard25